import { type FC, type MouseEventHandler } from 'react';
import classnames from 'classnames';
import slugify from 'dibs-slugify/exports/slugify.ts';

// components
import { FormattedNumber } from 'dibs-react-intl';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor.jsx';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { useSbSelector } from '../../../reducers/useSbSelector.ts';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

//styles
import styles from './SbSharedRefineMenuLink.scss';
import dibsCss from 'dibs-css';

type Props = {
    onClick: MouseEventHandler;
    text: string;
    count?: number | null;
    selected?: boolean;
    dataTn?: string;
    linkable?: boolean | null;
    linkReference?: string | null;
    className?: string;
    shouldIndent?: boolean;
    isHidden?: boolean;
    hasVectorSearchResults: boolean;
};

export const SbSharedRefineMenuLink: FC<Props> = ({
    text,
    count,
    onClick,
    linkReference,
    linkable,
    className,
    shouldIndent,
    dataTn,
    selected,
    isHidden,
    hasVectorSearchResults,
}) => {
    const refetchInFlight = useSbSelector(state => state.filters.refetchInFlight);
    const { isRemoveCountsVariant } = useServerVarsContext();

    const containerClass = classnames(styles.container, className, {
        [styles.selected]: selected,
        [styles.indent]: shouldIndent,
        'is-hidden': isHidden,
        [styles.disabled]: refetchInFlight,
    });

    const dataTnText = slugify(dataTn || text);

    return (
        <Link
            buyerLinkType="linkNoDecoration"
            onClick={onClick}
            className={containerClass}
            dataTn={`facet-link${selected ? '-selected' : ''}-${dataTnText}${
                refetchInFlight ? '-disabled' : ''
            }`}
        >
            <AbsoluteAnchor
                className={styles.text}
                dataTn={`facet-content-${dataTnText}`}
                linkReference={linkReference}
                linkable={linkable}
                inert
            >
                {text}
            </AbsoluteAnchor>
            {!!count && !isRemoveCountsVariant && !hasVectorSearchResults && (
                <span
                    className={classnames(
                        dibsCss.textBodySmallNormal,
                        dibsCss.mt3px,
                        dibsCss.mlXsmall,
                        refetchInFlight ? dibsCss.textIron : dibsCss.textSatan
                    )}
                    data-tn={`facet-count-${dataTnText}`}
                >
                    <FormattedNumber value={count} />
                </span>
            )}
        </Link>
    );
};
